import React, { createContext, useContext, useEffect, useState } from "react";

const I18nContext = createContext(null);

const dict = {
  pl: {
    nav: {
      camps: "Obozy",
      why: "Dlaczego my",
      programme: "Program",
      gallery: "Galeria",
      pricing: "Terminy",
      faq: "FAQ",
      contact: "Kontakt",
      signup: "Zapisz się",
      skatepark: "Skatepark",
      parents: "Dla rodziców",
      info: "Info",
      account: "Moje konto",
      privacy_policy: "Polityka prywatności"
    },
    hero: {
      kicker: "Obóz hulajnogowy · Warszawa · 8–16 lat",
      title_1: "Obóz, na którym dzieciaki",
      title_2: "kochają",
      title_3: "każdy dzień.",
      subtitle:
        "Obozy w największym krytym skateparku w Polsce. Profesjonalna kadra, opieka 24/7, mnóstwo atrakcji – i wszystko pod jednym dachem.",
      cta_summer: "Obóz letni",
      cta_winter: "Obóz zimowy",
      countdown: "Najbliższy obóz startuje za",
      next_label: "Lato 2026",
      no_upcoming_kicker: "Zapisy wkrótce",
      no_upcoming_title: "Nowe terminy już niedługo",
      no_upcoming_body: "Daj nam swój e-mail — uderzymy do Ciebie przed startem zapisów.",
      no_upcoming_cta: "Zapisz się do newslettera",
      days: "DNI",
      hours: "GODZ",
      minutes: "MIN",
      seconds: "SEK",
      trust_safety: "Opieka 24/7",
      trust_kids: "600+ dzieciaków rocznie",
      sticker_1: "od",
      sticker_2: "2 790 zł"
    },
    picker: {
      kicker: "Wybierz porę roku",
      title: "Lato czy zima – my organizujemy oba.",
      summer: {
        season: "Lato",
        title: "Letnie obozy hulajnogowe",
        body: "Wakacje pełne jazdy, bitew wodnych, parku trampolin, grilli i SPA. Kryty skatepark + zewnętrzne sekcje – jeździsz niezależnie od pogody.",
        cta: "Zobacz lato"
      },
      winter: {
        season: "Zima",
        title: "Zimowe obozy hulajnogowe",
        body: "Ferie w ciepłej hali. Skatepark, kino, ścianka wspinaczkowa i komfortowy hostel w skateparku. Mróz na zewnątrz – jazda pod dachem.",
        cta: "Zobacz zimę"
      }
    },
    trust: {
      kicker: "Dlaczego rodzice nam ufają",
      title: "Wszystko, co rodzic chce wiedzieć.",
      subtitle:
        "Bezpieczeństwo, kadra, lokalizacja, jedzenie. Mamy to ogarnięte w każdym detalu.",
      items: [
        { stat: "24/7", title: "Opieka non-stop", body: "Od momentu przyjęcia dziecka aż do oddania go w ręce rodzica." },
        { stat: "1:15", title: "Mała grupa", body: "Jeden instruktor na 15 uczestników. Indywidualne podejście." },
        { stat: "8+", title: "Sekcji parku", body: "Największy kryty skatepark w Polsce – AvePark Warszawa." },
        { stat: "100%", title: "Pasjonatów", body: "Kadra to instruktorzy, którzy sami startują i jeżdżą." }
      ]
    },
    activities: {
      kicker: "Co się dzieje na obozie",
      title: "Tu nie ma nudy.",
      subtitle:
        "Każdy dzień to mix sesji jazdy z instruktorami, treningu nowych trików i atrakcji towarzyszących."
    },
    schedule: {
      kicker: "Plan dnia",
      title: "Tak wygląda przykładowy dzień na Scootive Camp.",
      items: [
        { time: "09:00", title: "Poranny start", body: "Pobudka, lekki rozruch, śniadanie i przygotowanie do pierwszych zajęć.", icon: "Sun" },
        { time: "10:15", title: "Sesja 1 · Contesty", body: "Rywalizacja, zadania na hulajnogach i zajęcia szkoleniowe prowadzone przez instruktora.", icon: "Activity" },
        { time: "13:30", title: "Obiad i aktywności", body: "Przerwa na posiłek, regenerację oraz zabawy i integrację z wychowawcą.", icon: "Utensils" },
        { time: "14:30", title: "Sesja 2 · Szkolenia", body: "Szkolenia indywidualne, rozwijanie techniki oraz gry i zabawy dopasowane do grupy.", icon: "Activity" },
        { time: "18:30", title: "Kolacja i przerwa", body: "Wieczorny posiłek i chwila odpoczynku przed ostatnią sesją dnia.", icon: "Utensils" },
        { time: "19:15", title: "Sesja 3 · Wieczorna jazda", body: "Klimatyczna wieczorna jazda z podziałem na grupy i aktywnościami dopasowanymi do poziomu uczestników.", icon: "Activity" },
        { time: "22:00", title: "Cisza nocna", body: "Zakończenie dnia, odpoczynek i regeneracja przed kolejnym dniem na Scootive Camp.", icon: "Moon" }
      ]
    },
    facility: {
      kicker: "Nasz obiekt",
      title: "AvePark + Hostel",
      subtitle: "Wszystko w jednym budynku. Z pokoju do skateparku w 10 sekund.",
      skatepark_title: "Skatepark AvePark",
      skatepark_body:
        "Kryty, ogrzewany, klimatyzowany. Ponad 8 różnorodnych sekcji. Sekcje wewnętrzne i zewnętrzne. Jedyny taki obiekt w Polsce.",
      hostel_title: "Hostel",
      hostel_body:
        "Komfortowe pokoje 4–6 osobowe, Wi-Fi, szafy na ubrania i sprzęt, opieka wychowawców 24h."
    },
    camp_life: {
      kicker: "Tak wygląda obóz",
      title: "Camp life — w ruchu.",
      subtitle: "Krótkie kadry z naszych turnusów. Hulajnoga, śmiechy, kumple — i mnóstwo trików.",
      prev: "Poprzednie wideo",
      next: "Następne wideo",
      slide_label: "Wideo",
      mute: "Wycisz",
      unmute: "Włącz dźwięk",
      fullscreen: "Otwórz w pełnym oknie"
    },
    pricing: {
      kicker: "Terminy i ceny",
      title: "Wybierz turnus.",
      subtitle: "Liczba miejsc ograniczona. Decyduje kolejność zgłoszeń.",
      tab_summer: "Lato 2026",
      tab_winter: "Zima 2027",
      includes: "U nas",
      includes_title: "Wszystko w cenie",
      includes_items: [
        "Pobyt w hostelu AvePark",
        "Pełne wyżywienie (3 ciepłe posiłki)",
        "Codzienne zajęcia z instruktorami",
        "Atrakcje (SPA, trampoliny, ścianka, kino)",
        "Bezpłatny serwis hulajnogi",
        "Pakiet startowy (koszulka, bidon, naklejki)"
      ],
      cta: "Zapisz się teraz",
      sold_out: "Brak miejsc",
      few_left: "Ostatnie miejsca",
      loading: "Ładowanie terminów…",
      error: "Nie udało się pobrać terminów. Spróbuj za chwilę.",
      empty: "Wkrótce pojawią się nowe terminy."
    },
    reviews: {
      kicker: "Opinie rodziców",
      title: "Setki rodziców już nam zaufały.",
      subtitle: "Średnia 5.0 w Google."
    },
    skatepark: {
      kicker: "Nasz obiekt",
      title_1: "Skatepark",
      title_2: "AvePark",
      subtitle: "Największy kryty skatepark w Polsce. Powierzchnia ok. 3 000 m². Osiem sekcji jeżdżących, strefy rozrywkowe i hostel w jednym budynku.",
      address: "ul. Krakowiaków 80/98, Warszawa",
      features: [
        { title: "Klimatyzowany i ogrzewany", body: "Komfort przez cały rok – zimą ciepło, latem chłodno." },
        { title: "Ponad 8 sekcji", body: "Sekcje wewnętrzne i zewnętrzne, dla każdego poziomu." },
        { title: "Strefa relaksu", body: "Ping-pong, piłkarzyki, sala koszykówki." },
        { title: "Serwis hulajnogi", body: "Bezpłatny serwis na miejscu w trakcie obozu." },
        { title: "Wi-Fi w całym obiekcie", body: "Internet bezprzewodowy wszędzie." },
        { title: "Parking na miejscu", body: "Wygodny dojazd autem i komunikacją miejską." }
      ]
    },
    parents: {
      kicker: "Dla rodziców",
      title: "Wszystko, co musisz wiedzieć",
      subtitle: "Komfort, dokumenty, logistyka — wszystko w jednym miejscu.",
      tab_comfort: "Komfort",
      tab_documents: "Dokumenty",
      tab_logistics: "Logistyka",
      accommodation_title: "Nocleg",
      accommodation_subtitle: "Hostel w budynku skateparku – z pokoju do sesji w 10 sekund.",
      accommodation: [
        "Komfortowe pokoje 4–6 osobowe",
        "Łóżka z pościelą i ręcznikami",
        "Szafka dla każdego uczestnika",
        "Wspólne łazienki na piętrze",
        "Wi-Fi w całym budynku",
        "Strefa wspólna z grami i kanapami"
      ],
      meals_title: "Wyżywienie",
      meals_subtitle: "3 ciepłe posiłki dziennie. Diety i alergie ogarnięte.",
      meals: [
        { meal: "Śniadanie", body: "Naleśniki, jajecznica, owoce, jogurty, pieczywo. Bufet." },
        { meal: "Obiad", body: "Dwa dania + kompot. Domowe smaki, kotlety, makarony." },
        { meal: "Podwieczorek", body: "Owoce, batony, drożdżówki – energia przed sesją 2." },
        { meal: "Kolacja", body: "Tosty, kanapki, dania ciepłe. Czasem grill na zewnątrz." }
      ],
      comms_title: "Kontakt z dzieckiem",
      comms_subtitle: "Zawsze na bieżąco z tym, co dzieje się na obozie.",
      comms: [
        { title: "Codzienne relacje", body: "Zdjęcia i filmy z każdego dnia na IG i Facebooku." },
        { title: "Kontakt z kadrą", body: "Bezpośredni numer do kierownika obozu i wychowawcy." }
      ],
      diets_strong: "Diety i alergie:",
      diets_body: "wegetariańska, bezglutenowa, bezlaktozowa, halal, kosher i inne – obsługujemy. Wystarczy dać nam znać!"
    },
    info: {
      kicker: "Ważne informacje",
      title: "Co załatwić przed obozem",
      subtitle: "Dokumenty, lista rzeczy i kluczowe daty. Wszystko w jednym miejscu.",
      documents_title: "Dokumenty do pobrania",
      documents: [
        { name: "Regulamin obozu", desc: "Pełny regulamin pobytu.", file: "Regulamin-obozu.pdf" },
        { name: "OWU Scootive Camp 2026", desc: "Ogólne warunki uczestnictwa.", file: "owu-scootivecamp-2026_18-51-37_04-10-2025.pdf" },
        { name: "OWU Ubezpieczenia NNW", desc: "Ogólne warunki ubezpieczenia.", file: "OWUNNW.pdf" },
        { name: "Zaświadczenie organizatora", desc: "Wpis do rejestru organizatorów.", file: "avepark-zaswiadczenie-o-wpisnie-do-rejestru-organizatorow-avepark.pdf" },
        { name: "Gwarancja ubezpieczeniowa", desc: "Polisa 2026/27 (AvePark).", file: "GwarancjaUbezpieczeniowa_26_27.pdf" },
        { name: "OWU – koszty rezygnacji", desc: "Pełne warunki rezygnacji.", file: "owu-koszty-rezygnacji-a5-kolor-od-13-01-2022.pdf" },
        { name: "IPID – koszty rezygnacji", desc: "Karta produktu (skrót).", file: "avepark-ipid-koszty-rezygnacji-12-2021a.pdf" },
        { name: "Zgoda na odbiór dziecka", desc: "Wypełnia rodzic / opiekun.", file: "zgoda-na-odbior-dziecka.pdf" },
        { name: "Samodzielny powrót", desc: "Zgoda na powrót bez opiekuna.", file: "samodzielny-powrot.pdf" }
      ],
      card_alert_strong: "kartę kwalifikacyjną",
      card_alert_prefix: "Wypełnioną",
      card_alert_suffix: "przynieś w dniu rozpoczęcia obozu.",
      packing_title: "Co spakować",
      packing: [
        "Hulajnoga wyczynowa (własna)",
        "Kask + ochraniacze (kolana, łokcie, nadgarstki)",
        "Wygodne ubrania na min. 7 dni",
        "Buty do jazdy + dodatkowe na zmianę",
        "Strój sportowy + kostium kąpielowy",
        "Klapki, ręcznik, kosmetyki",
        "Bidon na wodę",
        "Ładowarka do telefonu",
        "Apteczka z lekami przyjmowanymi przez dziecko",
        "Czapka i krem z filtrem (lato) / ciepła kurtka (zima)"
      ],
      arrival_when: "Niedziela · 14:00–16:00",
      arrival_title: "Przyjazd i zakwaterowanie",
      arrival_body: "Odbiór dzieci, karty kwalifikacyjne, rozpakowanie.",
      departure_when: "Sobota · 11:00–13:00",
      departure_title: "Zakończenie i odbiór dzieci",
      departure_body: "Pokaz finałowy, pamiątkowe zdjęcia, oddanie dzieci rodzicom."
    },
    summerPage: {
      back: "Strona główna",
      sticker_prefix: "Lato",
      title_1: "Letni obóz",
      title_2: "hulajnogowy",
      subtitle: "Jazda, bitwy wodne, park trampolin, grill i SPA. Wakacje, jakich potrzebujesz.",
      parents_cta: "Info dla rodziców",
      stat_length: "Długość",
      stat_age: "Wiek",
      stat_location: "Lokalizacja",
      stat_price: "Cena od",
      stat_length_value: "7 dni",
      stat_length_unit: "dni",
      stat_location_value: "Warszawa",
      terms_kicker: "Terminy",
      terms_heading_prefix: "Lato"
    },
    winterPage: {
      back: "Strona główna",
      sticker_prefix: "Zima",
      title_1: "Zimowy obóz",
      title_2: "hulajnogowy",
      subtitle: "Kryty skatepark, kino, ścianka wspinaczkowa i ciepłe pokoje. Mróz na zewnątrz – jazda pod dachem.",
      parents_cta: "Info dla rodziców",
      stat_length: "Długość",
      stat_age: "Wiek",
      stat_location: "Lokalizacja",
      stat_price: "Cena od",
      stat_length_value: "7 dni",
      stat_length_unit: "dni",
      stat_location_value: "Warszawa",
      terms_kicker: "Terminy",
      terms_heading_prefix: "Zima"
    },
    faq: {
      kicker: "FAQ",
      title: "Pytania, które padają najczęściej.",
      cta_text: "Nie znalazłeś odpowiedzi? Napisz do nas.",
      items: [
        { q: "Gdzie znajduje się obóz i skatepark AvePark?", a: "W Warszawie przy ul. Krakowiaków 80/98 – największy kryty skatepark w Polsce." },
        { q: "Jak dojechać komunikacją publiczną / pociągiem?", a: "Z całej Polski najwygodniej pociągiem do stacji Warszawa Zachodnia, peron 1 tor 1, dowolną kolejką WKD do stacji Warszawa Raków (kup bilet na pierwszą strefę – kontrole bywają częste). Skatepark jest 100 m od stacji." },
        { q: "W jakim wieku musi być uczestnik?", a: "Z obozu mogą skorzystać dzieci w wieku 8–16 lat. Dzieci dzielone są na grupy wiekowe." },
        { q: "Czy obóz jest odpowiedni dla początkujących?", a: "Tak – uczestnicy to pełen przekrój: od dzieciaków, które pierwszy raz stają na hulajnodze, po zaawansowanych. Nasi instruktorzy w testowym przejeździe dzielą dzieci na grupy zgodnie z poziomem." },
        { q: "Co należy ze sobą zabrać na obóz?", a: "Pełna lista znajduje się w sekcji „Co spakować” na tej stronie. Najważniejsze: hulajnoga wyczynowa, kask, ochraniacze, ubrania na 7 dni, dokumenty." },
        { q: "Czy dzieci są ubezpieczone?", a: "Tak – każdy uczestnik jest objęty ubezpieczeniem NNW na kwotę 30–60 tys. zł, obowiązującym przez cały czas trwania obozu." },
        { q: "Czy obozy są zgłoszone do kuratorium oświaty?", a: "Tak – wszystkie nasze wyjazdy są zgłoszone i zaakceptowane przez kuratorium oświaty." },
        { q: "Kiedy zgłosić się na obóz w dniu rozpoczęcia?", a: "Rejestracja uczestników odbywa się w sobotę między 15:00 a 16:00. Zapraszamy serdecznie wcześniej – obiekt jest otwarty od 10:00." },
        { q: "Jakie dokumenty dostarczyć w dniu rozpoczęcia?", a: "Wypełnioną i podpisaną Kartę kwalifikacyjną oraz załącznik do niej. Wszystkie pliki znajdziesz w sekcji „Dokumenty do pobrania”." },
        { q: "Czy uczestnik musi mieć swoją hulajnogę?", a: "Polecamy własną, dobraną pod siebie. Jeśli ktoś nie ma jeszcze hulajnogi – przygotujemy mu sprzęt na miejscu, a nasi specjaliści w sklepie Scootive pomogą wybrać model." },
        { q: "Czy uczestnik może przyjechać i zgłosić się sam?", a: "Tak – młodzież może zgłosić się do rejestracji samodzielnie w sobotę 15:00–16:00, pod warunkiem że ma ze sobą wszystkie dokumenty wypełnione i podpisane przez rodziców." },
        { q: "Czy są jeszcze wolne miejsca na turnus X?", a: "Jeżeli możesz kliknąć „Zapisz się teraz” i rozpocząć rezerwację, znaczy to, że na danym turnusie jest jeszcze co najmniej jedno wolne miejsce." },
        { q: "Czy można przenieść rezerwację na inny termin lub osobę?", a: "Tak – w obu przypadkach napisz do nas na kontakt@avetravel.pl. Decyzję o przeniesieniu podejmujemy indywidualnie; może wiązać się z dodatkową opłatą, o której zawsze poinformujemy z wyprzedzeniem." },
        { q: "Jak dokonać płatności?", a: "Płatność wykonujesz w panelu Avetravel.pl przez PayU. Zaloguj się, przejdź do swojej rezerwacji i kliknij „Przejdź do płatności”. Każda transakcja ma indywidualny numer konta." },
        { q: "Jak wyglądają warunki noclegowe?", a: "W skateparku znajduje się hostel przeznaczony wyłącznie dla obozowiczów. Do dyspozycji są pokoje 4-, 6- i 8-osobowe z łóżkami piętrowymi. Każdy uczestnik ma własną szafkę oraz indywidualny kontakt. Na każdym piętrze znajdują się łazienki i poidełka z wodą." },
        { q: "Czy koledzy mogą zamieszkać razem w pokoju?", a: "Zgłoszenia o wspólne zakwaterowanie przyjmujemy do 7 dni przed turnusem na kontakt@avetravel.pl. Różnica wieku w pokoju nie powinna przekraczać 1 roku – nie połączymy 11-latka z grupą 15-latków." },
        { q: "Czy na terenie obozu jest punkt medyczny?", a: "Tak – ratownik medyczny dyżuruje na miejscu przez cały czas trwania obozu i dba o zdrowie uczestników." },
        { q: "Czy uczestnicy mogą wychodzić poza teren ośrodka?", a: "Nie – samodzielne opuszczanie obozu nie jest możliwe. Zaplanowane są wspólne wyjścia grupowe pod opieką wychowawców i instruktorów." },
        { q: "Jakie zasady obowiązują przy korzystaniu z telefonów?", a: "Nie zabieramy uczestnikom telefonów po przyjeździe na obóz. Mogą z nich korzystać rozsądnie – np. nagrywać swoje przejazdy, robić zdjęcia lub odpocząć przez chwilę między zajęciami. Jeżeli jednak telefon zaczyna przeszkadzać w aktywnym uczestnictwie w obozie, jest nadużywany lub używany w godzinach nocnych, kadra może go czasowo zdeponować. W takiej sytuacji wspólnie z uczestnikiem ustalamy indywidualne zasady korzystania z telefonu tak, aby nie wpływał on na odpoczynek, integrację i udział w zajęciach." },
        { q: "Czy w obozie może uczestniczyć osoba na specjalnej diecie?", a: "Tak – nasza kuchnia ogarnia diety wegetariańskie, bezglutenowe, bezlaktozowe, halal, kosher i inne. Zalecamy wcześniejszy kontakt z biurem w celu potwierdzenia szczegółów." },
        { q: "Jakie są dodatkowe koszty wyjazdu?", a: "Żadne – wszystkie atrakcje i zajęcia są wliczone w cenę obozu." },
        { q: "Czy w obiekcie można płacić kartą / Blikiem?", a: "Tak – wszystkie nasze terminale obsługują płatność kartą i przez Blika." },
        { q: "Czy dziecko po obozie może wrócić samodzielnie?", a: "Tak – w sobotę do 11:00, wyłącznie na podstawie pisemnej zgody rodziców (do pobrania w sekcji Dokumenty), dostarczonej do biura mailem lub osobiście." },
        { q: "Czy dziecko może odebrać inna osoba niż rodzic?", a: "Tak – dowolna pełnoletnia osoba wskazana przez rodziców. Wystarczy podpisać i przesłać „Zgodę na odbiór dziecka” na kontakt@avetravel.pl." },
        { q: "Co w przypadku dwóch turnusów z rzędu?", a: "Możesz odebrać dziecko po pierwszym turnusie i przekazać ponownie o 15:00 albo wypełnić zgodę na samodzielny pobyt – wtedy dziecko zostaje w obiekcie między turnusami (~4h) bez naszego nadzoru." }
      ]
    },
    crosspromo: {
      kicker: "Świat Scootive",
      title: "Więcej niż obóz",
      shop: { title: "Sklep Scootive", body: "Hulajnogi wyczynowe, części, akcesoria. Online + sklep w Warszawie.", cta: "Wejdź do sklepu" },
      park: { title: "AvePark", body: "Największy kryty skatepark w Polsce. Otwarty cały rok.", cta: "Zarezerwuj wejście" }
    },
    newsletter: {
      kicker: "Bądź na bieżąco",
      title: "Dostań info o nowych terminach.",
      subtitle: "Nowe turnusy, promocje i akcje specjalne. Zero spamu.",
      placeholder: "Twój e-mail",
      placeholder_name: "Twoje imię",
      cta: "Zapisz",
      success: "Dzięki! Jesteś na liście.",
      error: "Coś poszło nie tak. Spróbuj jeszcze raz."
    },
    contact: {
      kicker: "Kontakt",
      title: "Pisz, dzwoń.",
      address: "AvePark · ul. Krakowiaków 80/98, 02-255 Warszawa"
    },
    footer: {
      tagline: "Najlepszy obóz hulajnogowy w Polsce.",
      rights: "Wszystkie prawa zastrzeżone.",
      brand: "Scootive Camp",
      camp_col: "Obóz",
      camp_summer: "Lato",
      camp_winter: "Zima",
      camp_info: "Ważne info",
      shop_label: "Sklep Scootive",
      other: "Inne",
      privacy_link: "Polityka prywatności",
      cookie_settings: "Ustawienia cookies",
      social_label: "Śledź nas",
      organizer: "Organizator",
      tax_id: "NIP",
      regon: "REGON",
      krs: "KRS",
      registry_link: "Wpis do Rejestru Organizatorów Turystycznych (PDF)",
      address_label: "Adres",
      contact_label: "Kontakt",
      office_label: "Biuro AveTravel"
    }
  },
  uk: {
    nav: {
      camps: "Табори",
      why: "Чому ми",
      programme: "Програма",
      gallery: "Галерея",
      pricing: "Дати",
      faq: "FAQ",
      contact: "Контакти",
      signup: "Зареєструватись",
      skatepark: "Скейтпарк",
      parents: "Для батьків",
      info: "Інфо",
      account: "Мій кабінет",
      privacy_policy: "Політика конфіденційності"
    },
    hero: {
      kicker: "Самокатний табір · Варшава · 7–17 років",
      title_1: "Табір, де діти",
      title_2: "обожнюють",
      title_3: "кожен день.",
      subtitle:
        "7-денні табори в найбільшому критому скейтпарку Польщі. Професійні тренери, нагляд 24/7, безліч атракцій – і все під одним дахом.",
      cta_summer: "Літній табір",
      cta_winter: "Зимовий табір",
      countdown: "Найближчий табір стартує за",
      next_label: "Літо 2026",
      no_upcoming_kicker: "Реєстрація скоро",
      no_upcoming_title: "Нові дати вже скоро",
      no_upcoming_body: "Залиш свій e-mail — повідомимо тебе перед стартом реєстрації.",
      no_upcoming_cta: "Підписатися на розсилку",
      days: "ДНІВ",
      hours: "ГОД",
      minutes: "ХВ",
      seconds: "СЕК",
      trust_safety: "Нагляд 24/7",
      trust_kids: "600+ дітей щороку",
      sticker_1: "від",
      sticker_2: "2 790 zł"
    },
    picker: {
      kicker: "Обери пору року",
      title: "Літо чи зима – ми проводимо обидва.",
      summer: {
        season: "Літо",
        title: "Літні самокатні табори",
        body: "Канікули, повні їзди, водних битв, парку батутів, грилю та SPA. Критий скейтпарк + зовнішні зони – катаєшся незалежно від погоди.",
        cta: "Дізнатись про літо"
      },
      winter: {
        season: "Зима",
        title: "Зимові самокатні табори",
        body: "Канікули в теплій залі. Скейтпарк, кіно, скеледром і комфортний хостел поруч з парком. На вулиці мороз – їзда під дахом.",
        cta: "Дізнатись про зиму"
      }
    },
    trust: {
      kicker: "Чому батьки нам довіряють",
      title: "Все, що батьки хочуть знати.",
      subtitle:
        "Безпека, тренери, локація, харчування. У нас усе під контролем до дрібниць.",
      items: [
        { stat: "24/7", title: "Нагляд цілодобово", body: "З моменту приймання дитини до повернення її батькам." },
        { stat: "1:15", title: "Маленькі групи", body: "Один тренер на 15 учасників. Індивідуальний підхід." },
        { stat: "5+", title: "Зон у парку", body: "Найбільший критий скейтпарк у Польщі – AvePark Warszawa." },
        { stat: "100%", title: "Фанатів справи", body: "Наші тренери самі змагаються та катаються." }
      ]
    },
    activities: {
      kicker: "Що відбувається в таборі",
      title: "Тут немає нудьги.",
      subtitle:
        "Кожен день – це мікс сесій з тренерами, тренувань нових трюків і додаткових атракцій."
    },
    schedule: {
      kicker: "Розклад дня",
      title: "Так виглядає типовий день у Scootive Camp.",
      items: [
        { time: "08:00", title: "Підйом і сніданок", body: "Млинці, омлет, фрукти – здоровий старт дня." },
        { time: "09:30", title: "Сесія 1 · З тренером", body: "Тренування трюків, основ і прогресії в скейтпарку." },
        { time: "12:30", title: "Обід і відпочинок", body: "Домашня їжа, час для розслаблення." },
        { time: "14:00", title: "Атракція дня", body: "Парк батутів, скеледром, водна битва або SPA." },
        { time: "17:00", title: "Сесія 2 · Free ride", body: "Вільна їзда, власні проєкти, запис відео." },
        { time: "19:00", title: "Вечеря", body: "Домашня їжа і вечірнє спілкування." },
        { time: "20:30", title: "Тематичний вечір", body: "Кіно, ігри, змагання, перегляд відео з дня." }
      ]
    },
    facility: {
      kicker: "Наш об'єкт",
      title: "AvePark + Хостел",
      subtitle: "Все в одній будівлі. Зі своєї кімнати до скейтпарку – 30 секунд.",
      skatepark_title: "Скейтпарк AvePark",
      skatepark_body:
        "Критий, опалюваний, з кондиціонером. Понад 6 різних зон. Внутрішні та зовнішні зони. Єдиний такий об'єкт у Польщі.",
      hostel_title: "Хостел",
      hostel_body:
        "Комфортні кімнати на 4–6 осіб, Wi-Fi, шафи для речей і обладнання, нагляд вихователів 24 години."
    },
    camp_life: {
      kicker: "Як виглядає табір",
      title: "Camp life — у русі.",
      subtitle: "Короткі кадри з наших змін. Самокат, сміх, друзі — і безліч трюків.",
      prev: "Попереднє відео",
      next: "Наступне відео",
      slide_label: "Відео",
      mute: "Вимкнути звук",
      unmute: "Увімкнути звук",
      fullscreen: "Відкрити на весь екран"
    },
    pricing: {
      kicker: "Дати і ціни",
      title: "Обери зміну.",
      subtitle: "Кількість місць обмежена. Вирішує черговість заявок.",
      tab_summer: "Літо 2026",
      tab_winter: "Зима 2027",
      includes: "У ціну входить",
      includes_title: "Все включено в ціну",
      includes_items: [
        "7 днів проживання в хостелі AvePark",
        "Повне харчування (3 прийоми їжі + перекуси)",
        "Усі заняття з тренерами",
        "Атракції (SPA, батути, скеледром, водна битва)",
        "Безкоштовний сервіс самоката",
        "Стартовий пакет (футболка, пляшка, наклейки)"
      ],
      cta: "Зареєструватись зараз",
      sold_out: "Місць немає",
      few_left: "Останні місця",
      loading: "Завантаження дат…",
      error: "Не вдалося отримати дати. Спробуй пізніше.",
      empty: "Незабаром з'являться нові дати."
    },
    reviews: {
      kicker: "Відгуки батьків",
      title: "Сотні батьків нам уже довірили дітей.",
      subtitle: "Середня оцінка 5.0 у Google."
    },
    skatepark: {
      kicker: "Наш об'єкт",
      title_1: "Скейтпарк",
      title_2: "AvePark",
      subtitle: "Найбільший критий скейтпарк у Польщі. Площа близько 3 500 м². П'ять зон для катання, розважальні зони і хостел в одній будівлі.",
      address: "ul. Krakowiaków 80/98, Warszawa",
      features: [
        { title: "З кондиціонером і опаленням", body: "Комфорт цілий рік – взимку тепло, влітку прохолодно." },
        { title: "Понад 6 зон", body: "Внутрішні та зовнішні зони, для будь-якого рівня." },
        { title: "Зона релаксу", body: "Парк батутів, скеледром, пінг-понг, настільний футбол." },
        { title: "Сервіс самоката", body: "Безкоштовний сервіс на місці протягом табору." },
        { title: "Wi-Fi у всьому об'єкті", body: "Бездротовий інтернет всюди." },
        { title: "Парковка на місці", body: "Зручний доїзд авто і громадським транспортом." }
      ]
    },
    parents: {
      kicker: "Для батьків",
      title: "Все, що ти маєш знати",
      subtitle: "Комфорт, документи, логістика — все в одному місці.",
      tab_comfort: "Комфорт",
      tab_documents: "Документи",
      tab_logistics: "Логістика",
      accommodation_title: "Проживання",
      accommodation_subtitle: "Хостел у будівлі скейтпарку – зі своєї кімнати до сесії 30 секунд.",
      accommodation: [
        "Комфортні кімнати на 4–6 осіб",
        "Ліжка з постільною білизною та рушниками",
        "Шафи з замком",
        "Спільні ванні кімнати на поверсі",
        "Wi-Fi у всій будівлі",
        "Спільна зона з іграми та диванами"
      ],
      meals_title: "Харчування",
      meals_subtitle: "4 прийоми їжі на день + перекуси. Дієти й алергії – без проблем.",
      meals: [
        { meal: "Сніданок", body: "Млинці, омлет, фрукти, йогурти, випічка. Шведський стіл." },
        { meal: "Обід", body: "Дві страви + компот. Домашні смаки, вареники, котлети, паста." },
        { meal: "Перекус", body: "Фрукти, батончики, булочки – енергія перед сесією 2." },
        { meal: "Вечеря", body: "Тости, бутерброди, гарячі страви. Іноді гриль на свіжому повітрі." }
      ],
      comms_title: "Зв'язок з дитиною",
      comms_subtitle: "Завжди в курсі того, що відбувається в таборі.",
      comms: [
        { title: "Щоденні стрічки", body: "Фото та відео з кожного дня в IG та Facebook." },
        { title: "Дзвінок дитині", body: "Діти мають свої телефони – завжди можна подзвонити." },
        { title: "Контакт з персоналом", body: "Прямий номер до керівника табору і вихователя." }
      ],
      diets_strong: "Дієти й алергії:",
      diets_body: "вегетаріанська, безглютенова, безлактозна, халяль, кошер та інші – забезпечуємо. Просто дай нам знати!"
    },
    info: {
      kicker: "Важлива інформація",
      title: "Що зробити перед табором",
      subtitle: "Документи, список речей і ключові дати. Все в одному місці.",
      documents_title: "Документи для завантаження",
      documents: [
        { name: "Регламент табору", desc: "Повний регламент перебування.", file: "regulamin-obozu.pdf" },
        { name: "Загальні умови Scootive Camp 2026", desc: "Загальні умови участі.", file: "owu-scootivecamp-2026.pdf" },
        { name: "Свідоцтво організатора", desc: "Запис у реєстрі організаторів.", file: "zaswiadczenie-rejestru-organizatorow.pdf" },
        { name: "Гарантія страхування", desc: "Поліс 2026/27 (AvePark).", file: "gwarancja-ubezpieczeniowa.pdf" },
        { name: "Загальні умови NNW – Generali", desc: "Страхування від нещасних випадків.", file: "owu-nnw-generali.pdf" },
        { name: "Загальні умови – витрати на скасування", desc: "Повні умови скасування.", file: "owu-koszty-rezygnacji.pdf" },
        { name: "IPID – витрати на скасування", desc: "Картка продукту (короткий опис).", file: "ipid-koszty-rezygnacji.pdf" },
        { name: "Згода на отримання дитини", desc: "Заповнюють батьки / опікуни.", file: "zgoda-na-odbior-dziecka.pdf" },
        { name: "Самостійне повернення", desc: "Згода на повернення без супроводу.", file: "samodzielny-powrot.pdf" }
      ],
      card_alert_strong: "кваліфікаційну картку",
      card_alert_prefix: "Заповнену",
      card_alert_suffix: "принеси в день початку табору.",
      packing_title: "Що зібрати",
      packing: [
        "Самокат для трюків (свій)",
        "Шолом + захист (коліна, лікті, зап'ястя)",
        "Зручний одяг мінімум на 7 днів",
        "Взуття для їзди + додаткове на зміну",
        "Спортивний костюм + купальник",
        "Капці, рушник, косметика",
        "Пляшка для води",
        "Зарядка для телефону",
        "Аптечка з ліками, які приймає дитина",
        "Кепка і крем від сонця (літо) / тепла куртка (зима)"
      ],
      arrival_when: "Неділя · 14:00–16:00",
      arrival_title: "Приїзд і заселення",
      arrival_body: "Прийом дітей, кваліфікаційні картки, розпакування.",
      departure_when: "Субота · 11:00–13:00",
      departure_title: "Закінчення і повернення дітей",
      departure_body: "Фінальний показ, пам'ятні фото, передача дітей батькам."
    },
    summerPage: {
      back: "Головна",
      sticker_prefix: "Літо",
      title_1: "Літній",
      title_2: "самокатний табір",
      subtitle: "7 днів їзди, водних битв, парку батутів, грилю та SPA. Канікули, які тобі потрібні.",
      parents_cta: "Інфо для батьків",
      stat_length: "Тривалість",
      stat_age: "Вік",
      stat_location: "Локація",
      stat_price: "Ціна від",
      stat_length_value: "7 днів",
      stat_length_unit: "днів",
      stat_location_value: "Варшава",
      terms_kicker: "Дати",
      terms_heading_prefix: "Літо"
    },
    winterPage: {
      back: "Головна",
      sticker_prefix: "Зима",
      title_1: "Зимовий",
      title_2: "самокатний табір",
      subtitle: "7 днів критого скейтпарку, кіно, скеледрому і теплих кімнат. На вулиці мороз – їзда під дахом.",
      parents_cta: "Інфо для батьків",
      stat_length: "Тривалість",
      stat_age: "Вік",
      stat_location: "Локація",
      stat_price: "Ціна від",
      stat_length_value: "7 днів",
      stat_length_unit: "днів",
      stat_location_value: "Варшава",
      terms_kicker: "Дати",
      terms_heading_prefix: "Зима"
    },
    faq: {
      kicker: "FAQ",
      title: "Найчастіші питання.",
      cta_text: "Не знайшов відповіді? Напиши нам.",
      items: [
        { q: "Де знаходиться табір і скейтпарк AvePark?", a: "У Варшаві за адресою ul. Krakowiaków 80/98 – найбільший критий скейтпарк у Польщі." },
        { q: "Як дістатися громадським транспортом / поїздом?", a: "З усієї Польщі найзручніше поїздом до станції Warszawa Zachodnia, перон 1 колія 1, будь-якою електричкою WKD до станції Warszawa Raków (купуй квиток на першу зону – перевірки бувають часті). Скейтпарк за 100 м від станції." },
        { q: "Якого віку має бути учасник?", a: "У таборі можуть брати участь діти 7–17 років. Дітей розділяють на вікові групи." },
        { q: "Чи табір підходить для початківців?", a: "Так – серед учасників є повний спектр: від дітей, які вперше стають на самокат, до досвідчених. Наші тренери на тестовому проїзді розділяють дітей на групи відповідно до рівня." },
        { q: "Що взяти з собою в табір?", a: "Повний список знаходиться в розділі „Що зібрати” на цій сторінці. Найважливіше: самокат для трюків, шолом, захист, одяг на 7 днів, документи." },
        { q: "Чи діти застраховані?", a: "Так – кожен учасник застрахований за NNW на суму 30–60 тис. zł, поліс діє протягом усього табору." },
        { q: "Чи табори зареєстровані в куратораті освіти?", a: "Так – усі наші виїзди зареєстровані та схвалені куратораті освіти." },
        { q: "Коли з'явитися в день початку?", a: "Реєстрація учасників відбувається в суботу між 15:00 та 16:00. Запрошуємо раніше – об'єкт відкритий від 10:00." },
        { q: "Які документи потрібні в день початку?", a: "Заповнену і підписану кваліфікаційну картку та додаток до неї. Усі файли є в розділі „Документи для завантаження”." },
        { q: "Чи учасник має мати свій самокат?", a: "Рекомендуємо власний, підібраний під себе. Якщо ще немає самоката – підготуємо обладнання на місці, а наші спеціалісти у магазині Scootive допоможуть обрати модель." },
        { q: "Чи учасник може приїхати самостійно?", a: "Так – підлітки можуть зареєструватися самостійно в суботу 15:00–16:00 за умови, що мають усі документи, заповнені та підписані батьками." },
        { q: "Чи є ще вільні місця на зміну X?", a: "Якщо можеш натиснути „Зареєструватись зараз” і розпочати бронювання – значить, на цій зміні є щонайменше одне вільне місце." },
        { q: "Чи можна перенести бронювання на іншу дату або особу?", a: "Так – в обох випадках напиши нам на kontakt@avetravel.pl. Рішення приймаємо індивідуально; може бути додаткова оплата, про яку завжди повідомимо заздалегідь." },
        { q: "Як здійснити оплату?", a: "Оплата здійснюється в панелі Avetravel.pl через PayU. Увійди, перейди до свого бронювання і натисни „Перейти до оплати”. Кожна транзакція має індивідуальний номер рахунку." },
        { q: "Які умови проживання?", a: "У скейтпарку є хостел виключно для учасників табору. Кімнати на 4, 6 і 8 осіб з двоповерховими ліжками. Кожен учасник має власну шафку і розетку для зарядки телефону. Ванні кімнати та питна вода на кожному поверсі." },
        { q: "Чи друзі можуть жити в одній кімнаті?", a: "Заявки на спільне розміщення приймаємо до 7 днів перед зміною на kontakt@avetravel.pl. Різниця у віці в кімнаті не повинна перевищувати 1 рік – не помістимо 11-річного з групою 15-річних." },
        { q: "Чи на території табору є медпункт?", a: "Так – медичний рятувальник чергує на місці протягом усього табору і дбає про здоров'я учасників." },
        { q: "Чи учасники можуть виходити за межі об'єкта?", a: "Ні – самостійно покидати табір не дозволено. Заплановані спільні групові виходи під наглядом вихователів і тренерів." },
        { q: "Чи може брати участь особа на спеціальній дієті?", a: "Так – наша кухня обслуговує вегетаріанські, безглютенові, безлактозні, халяль, кошер та інші дієти. Радимо заздалегідь зв'язатися з офісом для уточнення деталей." },
        { q: "Які додаткові витрати?", a: "Жодних – усі атракції та заняття включено в ціну табору." },
        { q: "Чи можна платити карткою / Blikiem?", a: "Так – усі наші термінали приймають оплату карткою та через Blik." },
        { q: "Чи дитина після табору може повернутися самостійно?", a: "Так – у суботу до 11:00, виключно на підставі письмової згоди батьків (для завантаження в розділі Документи), доставленої в офіс електронкою або особисто." },
        { q: "Чи дитину може забрати інша особа, не батько/мати?", a: "Так – будь-яка повнолітня особа, вказана батьками. Достатньо підписати і надіслати „Згоду на отримання дитини” на kontakt@avetravel.pl." },
        { q: "А якщо дві зміни підряд?", a: "Можеш забрати дитину після першої зміни і знову передати о 15:00 або заповнити згоду на самостійне перебування – тоді дитина залишається в об'єкті між змінами (~4 години) без нашого нагляду." }
      ]
    },
    crosspromo: {
      kicker: "Світ Scootive",
      title: "Більше, ніж табір",
      shop: { title: "Магазин Scootive", body: "Самокати для трюків, запчастини, аксесуари. Онлайн + магазин у Варшаві.", cta: "До магазину" },
      park: { title: "AvePark", body: "Найбільший критий скейтпарк у Польщі. Відкритий цілий рік.", cta: "Забронювати вхід" }
    },
    newsletter: {
      kicker: "Будь у курсі",
      title: "Дізнавайся про нові дати першим.",
      subtitle: "Нові зміни, акції та спеціальні пропозиції. Жодного спаму.",
      placeholder: "Твій e-mail",
      placeholder_name: "Твоє ім'я",
      cta: "Підписатись",
      success: "Дякуємо! Ти у списку.",
      error: "Щось пішло не так. Спробуй ще раз."
    },
    contact: {
      kicker: "Контакти",
      title: "Пиши, дзвони.",
      address: "AvePark · ul. Krakowiaków 80/98, 02-255 Warszawa"
    },
    footer: {
      tagline: "Найкращий самокатний табір у Польщі.",
      rights: "Усі права захищено.",
      brand: "Scootive Camp",
      camp_col: "Табір",
      camp_summer: "Літо",
      camp_winter: "Зима",
      camp_info: "Важливе інфо",
      shop_label: "Магазин Scootive",
      other: "Інше",
      privacy_link: "Політика конфіденційності",
      cookie_settings: "Налаштування cookies",
      social_label: "Слідкуй за нами",
      organizer: "Організатор",
      tax_id: "NIP",
      regon: "REGON",
      krs: "KRS",
      registry_link: "Запис у реєстрі організаторів туризму (PDF)",
      address_label: "Адреса",
      contact_label: "Контакти",
      office_label: "Офіс AveTravel"
    }
  },
  en: {
    nav: {
      camps: "Camps", why: "Why us", programme: "Programme", gallery: "Gallery",
      pricing: "Dates", faq: "FAQ", contact: "Contact", signup: "Sign up",
      skatepark: "Skatepark", parents: "For parents", info: "Info",
      account: "My account", privacy_policy: "Privacy Policy"
    },
    hero: {
      kicker: "Scooter camp · Warsaw · ages 7–17",
      title_1: "The camp where kids",
      title_2: "love",
      title_3: "every single day.",
      subtitle:
        "7-day camps inside Poland's largest indoor skatepark. Pro coaches, 24/7 supervision, tons of attractions – all under one roof.",
      cta_summer: "Summer camp",
      cta_winter: "Winter camp",
      countdown: "Next camp starts in",
      next_label: "Summer 2026",
      no_upcoming_kicker: "Sign-ups soon",
      no_upcoming_title: "New dates coming soon",
      no_upcoming_body: "Drop your email — we'll ping you before sign-ups go live.",
      no_upcoming_cta: "Join the newsletter",
      days: "DAYS", hours: "HRS", minutes: "MIN", seconds: "SEC",
      trust_safety: "24/7 care",
      trust_kids: "600+ kids per year",
      sticker_1: "from",
      sticker_2: "PLN 2 790"
    },
    picker: {
      kicker: "Pick a season",
      title: "Summer or winter — we run both.",
      summer: { season: "Summer", title: "Summer scooter camps", body: "Holidays full of riding, water battles, trampolines, grills and SPA. Indoor + outdoor sections, ride no matter the weather.", cta: "See summer" },
      winter: { season: "Winter", title: "Winter scooter camps", body: "Winter break in a heated hall. Skatepark, cinema, climbing wall and a comfy hostel right next door.", cta: "See winter" }
    },
    trust: {
      kicker: "Why parents trust us",
      title: "Everything a parent needs to know.",
      subtitle: "Safety, staff, location, food. We've got it covered.",
      items: [
        { stat: "24/7", title: "Non-stop care", body: "From drop-off to pick-up. Always supervised." },
        { stat: "1:15", title: "Small groups", body: "One instructor per 15 kids. Individual approach." },
        { stat: "5+", title: "Park sections", body: "Poland's largest indoor skatepark – AvePark Warsaw." },
        { stat: "100%", title: "Real riders", body: "Coaches who ride and compete themselves." }
      ]
    },
    activities: {
      kicker: "What happens at camp",
      title: "Zero downtime.",
      subtitle: "Every day mixes coaching sessions, new tricks and side attractions."
    },
    schedule: {
      kicker: "Daily plan",
      title: "A typical day at Scootive Camp.",
      items: [
        { time: "08:00", title: "Wake-up & breakfast", body: "Pancakes, eggs, fruits – healthy start." },
        { time: "09:30", title: "Session 1 · Coached", body: "Tricks, basics, progression." },
        { time: "12:30", title: "Lunch & chill", body: "Home cooking, time to relax." },
        { time: "14:00", title: "Daily attraction", body: "Trampoline park, climbing wall, water battle or SPA." },
        { time: "17:00", title: "Session 2 · Free ride", body: "Open ride, own projects, edits filming." },
        { time: "19:00", title: "Dinner", body: "Home cooking and evening hangout." },
        { time: "20:30", title: "Themed night", body: "Cinema, games, contests, watching the day's edits." }
      ]
    },
    facility: {
      kicker: "Our facility",
      title: "AvePark + Hostel",
      subtitle: "All in one building. From your room to the park in 30 seconds.",
      skatepark_title: "AvePark Skatepark",
      skatepark_body: "Indoor, heated, AC. 6+ varied sections. Indoor & outdoor zones. The only one of its kind in Poland.",
      hostel_title: "Hostel",
      hostel_body: "Comfortable 4–6 person rooms, Wi-Fi everywhere, lockers, 24h supervision."
    },
    camp_life: {
      kicker: "This is camp life",
      title: "Camp life — in motion.",
      subtitle: "Short clips from our turns. Scooters, laughs, friends — and a ton of tricks.",
      prev: "Previous video",
      next: "Next video",
      slide_label: "Video",
      mute: "Mute",
      unmute: "Unmute",
      fullscreen: "Open in full screen"
    },
    pricing: {
      kicker: "Dates & prices",
      title: "Pick your week.",
      subtitle: "Limited spots. First come, first served.",
      tab_summer: "Summer 2026",
      tab_winter: "Winter 2027",
      includes: "Includes",
      includes_title: "Everything included",
      includes_items: [
        "7 nights at AvePark hostel",
        "Full board (3 meals + snacks)",
        "All coached sessions",
        "All side attractions (SPA, trampolines, climbing, water battle)",
        "Free scooter service",
        "Starter kit (t-shirt, bottle, stickers)"
      ],
      cta: "Sign up now",
      sold_out: "Sold out",
      few_left: "Few spots left",
      loading: "Loading dates…",
      error: "Couldn't fetch dates. Try again in a moment.",
      empty: "New dates are coming soon."
    },
    reviews: {
      kicker: "Parent reviews",
      title: "Hundreds of parents already trust us.",
      subtitle: "5.0 rating on Google."
    },
    skatepark: {
      kicker: "Our facility",
      title_1: "Skatepark",
      title_2: "AvePark",
      subtitle: "Poland's largest indoor skatepark. Around 3,500 m². Five riding sections, entertainment zones and a hostel under one roof.",
      address: "Krakowiaków 80/98, Warsaw",
      features: [
        { title: "Heated and air-conditioned", body: "All-year comfort – warm in winter, cool in summer." },
        { title: "6+ sections", body: "Indoor and outdoor sections for every level." },
        { title: "Chill zone", body: "Ping pong, foosball, basketball." },
        { title: "On-site scooter service", body: "Free scooter service while you ride." },
        { title: "Wi-Fi everywhere", body: "Wireless internet across the whole facility." },
        { title: "On-site parking", body: "Easy access by car or public transport." }
      ]
    },
    parents: {
      kicker: "For parents",
      title: "Everything you need to know",
      subtitle: "Comfort, documents, logistics — all in one place.",
      tab_comfort: "Comfort",
      tab_documents: "Documents",
      tab_logistics: "Logistics",
      accommodation_title: "Lodging",
      accommodation_subtitle: "Hostel inside the skatepark building — 30 seconds from your room to the ramps.",
      accommodation: [
        "Comfortable 4–6 person rooms",
        "Beds with bedding and towels",
        "Lockable wardrobes",
        "Shared bathrooms on each floor",
        "Wi-Fi throughout the building",
        "Common area with games and couches"
      ],
      meals_title: "Meals",
      meals_subtitle: "4 meals a day + snacks. Diets and allergies handled.",
      meals: [
        { meal: "Breakfast", body: "Pancakes, scrambled eggs, fruit, yoghurts, bread. Buffet." },
        { meal: "Lunch", body: "Two courses + drink. Home-style cooking, dumplings, schnitzel, pasta." },
        { meal: "Snack", body: "Fruit, bars, pastries — fuel before session 2." },
        { meal: "Dinner", body: "Toasts, sandwiches, hot dishes. Sometimes a BBQ outside." }
      ],
      comms_title: "Contact with your kid",
      comms_subtitle: "Always in the loop on what's happening at camp.",
      comms: [
        { title: "Daily updates", body: "Photos and videos every day on Instagram and Facebook." },
        { title: "Phone with your kid", body: "Kids have their phones — call them anytime." },
        { title: "Direct line to staff", body: "Direct number to the camp manager and counsellor." }
      ],
      diets_strong: "Diets and allergies:",
      diets_body: "vegetarian, gluten-free, lactose-free, halal, kosher and others — covered. Just let us know!"
    },
    info: {
      kicker: "Important info",
      title: "Sort it out before camp",
      subtitle: "Documents, packing list and key dates. All in one place.",
      documents_title: "Documents to download",
      documents: [
        { name: "Camp rules", desc: "Full stay regulations.", file: "regulamin-obozu.pdf" },
        { name: "Scootive Camp 2026 T&Cs", desc: "Full participation terms.", file: "owu-scootivecamp-2026.pdf" },
        { name: "Operator certificate", desc: "Tour operator registry entry.", file: "zaswiadczenie-rejestru-organizatorow.pdf" },
        { name: "Insurance certificate", desc: "Policy 2026/27 (AvePark).", file: "gwarancja-ubezpieczeniowa.pdf" },
        { name: "Generali NNW T&Cs", desc: "Accident insurance terms.", file: "owu-nnw-generali.pdf" },
        { name: "Cancellation T&Cs", desc: "Full cancellation terms.", file: "owu-koszty-rezygnacji.pdf" },
        { name: "Cancellation IPID", desc: "Product info sheet.", file: "ipid-koszty-rezygnacji.pdf" },
        { name: "Child pick-up consent", desc: "Filled in by parent / guardian.", file: "zgoda-na-odbior-dziecka.pdf" },
        { name: "Solo return consent", desc: "Consent for unaccompanied return.", file: "samodzielny-powrot.pdf" }
      ],
      card_alert_strong: "qualification form",
      card_alert_prefix: "Bring the completed",
      card_alert_suffix: "on the first day of camp.",
      packing_title: "What to pack",
      packing: [
        "Pro scooter (own one)",
        "Helmet + pads (knees, elbows, wrists)",
        "Comfy clothes for at least 7 days",
        "Riding shoes + extras to change",
        "Sportswear + swimsuit",
        "Flip-flops, towel, toiletries",
        "Water bottle",
        "Phone charger",
        "First-aid kit with any meds your kid takes",
        "Cap and sunscreen (summer) / warm jacket (winter)"
      ],
      arrival_when: "Sunday · 2:00–4:00 PM",
      arrival_title: "Arrival and check-in",
      arrival_body: "Drop-off, qualification forms, unpacking.",
      departure_when: "Saturday · 11:00 AM–1:00 PM",
      departure_title: "Closing and pick-up",
      departure_body: "Final showcase, group photos, kids handed back to parents."
    },
    summerPage: {
      back: "Home",
      sticker_prefix: "Summer",
      title_1: "Summer",
      title_2: "scooter camp",
      subtitle: "7 days of riding, water battles, trampolines, BBQs and SPA. The holiday you need.",
      parents_cta: "Info for parents",
      stat_length: "Length",
      stat_age: "Age",
      stat_location: "Location",
      stat_price: "From",
      stat_length_value: "7 days",
      stat_length_unit: "days",
      stat_location_value: "Warsaw",
      terms_kicker: "Dates",
      terms_heading_prefix: "Summer"
    },
    winterPage: {
      back: "Home",
      sticker_prefix: "Winter",
      title_1: "Winter",
      title_2: "scooter camp",
      subtitle: "7 days of indoor skatepark, cinema, climbing wall and cosy rooms. Frost outside – riding under the roof.",
      parents_cta: "Info for parents",
      stat_length: "Length",
      stat_age: "Age",
      stat_location: "Location",
      stat_price: "From",
      stat_length_value: "7 days",
      stat_length_unit: "days",
      stat_location_value: "Warsaw",
      terms_kicker: "Dates",
      terms_heading_prefix: "Winter"
    },
    faq: {
      kicker: "FAQ",
      title: "Questions we hear most.",
      cta_text: "Didn't find an answer? Reach out.",
      items: [
        { q: "Where is the camp and AvePark skatepark?", a: "In Warsaw at Krakowiaków 80/98 — Poland's largest indoor skatepark." },
        { q: "How do I get there by public transport?", a: "Take the train to Warszawa Zachodnia, then any WKD line from platform 1, track 1 to Warszawa Raków station (zone 1 ticket — controls are common). The skatepark is 100 m from the station." },
        { q: "What ages can join?", a: "7–17 years old. We split kids into age groups." },
        { q: "Is the camp suitable for beginners?", a: "Yes — our riders span the full spectrum, from kids on a scooter for the first time to advanced riders. Instructors split groups by skill on day one." },
        { q: "What should I pack?", a: "Full list is in the \"What to pack\" section above. Essentials: pro scooter, helmet, pads, clothes for 7 days, documents." },
        { q: "Are the kids insured?", a: "Yes — every participant is covered by accident insurance (NNW) for 30,000–60,000 PLN, valid throughout the entire stay." },
        { q: "Are camps registered with the education authority?", a: "Yes — every trip is registered with and approved by the Polish education authority (kuratorium)." },
        { q: "When does check-in happen on day one?", a: "Saturday 3:00–4:00 PM. The facility opens at 10:00 AM if you'd like to arrive earlier." },
        { q: "Which documents do I bring on day one?", a: "Filled and signed Qualification Form + its appendix. All files are in the \"Documents\" section." },
        { q: "Does my kid need their own scooter?", a: "We recommend bringing your own. If not — we'll provide a scooter on-site, and our Scootive shop staff can help pick the right model." },
        { q: "Can my kid check in alone?", a: "Yes — teens can register themselves Saturday 3:00–4:00 PM, as long as they bring all parent-signed documents." },
        { q: "Are there spots left on a specific turn?", a: "If you can click \"Sign up now\" and start a booking, there's at least one spot still open." },
        { q: "Can I move a booking to a different turn or person?", a: "Yes — email kontakt@avetravel.pl. Decisions are case-by-case and may include a small fee, always communicated upfront." },
        { q: "How do I pay?", a: "Payment is in the Avetravel.pl panel via PayU. Log in, open your booking, click \"Go to payment\". Each transaction has a unique account number." },
        { q: "What's the lodging like?", a: "An on-site hostel exclusively for campers. 4-, 6- and 8-person rooms with bunk beds. Each kid has their own locker and a charging plug. Showers and water fountains on every floor." },
        { q: "Can friends share a room?", a: "Submit a room-mate request up to 7 days before camp at kontakt@avetravel.pl. Age difference can't exceed 1 year — we won't put an 11-year-old with 15-year-olds." },
        { q: "Is there a medic on site?", a: "Yes — a paramedic is on-site for the entire duration, looking after the kids' health." },
        { q: "Can the kids leave the facility on their own?", a: "No — solo walks outside are not allowed. We organise group outings under counsellor and instructor supervision." },
        { q: "Can my kid join with a special diet?", a: "Yes — we cover vegetarian, gluten-free, lactose-free, halal, kosher and others. Reach out to confirm details before sign-up." },
        { q: "Are there any extra costs?", a: "None — every activity and trip is included in the camp price." },
        { q: "Can I pay by card / Blik on-site?", a: "Yes — every terminal supports card and Blik." },
        { q: "Can my kid go home alone after camp?", a: "Yes — Saturday until 11:00 AM, only with a written parent consent (download in the Documents section), submitted to the office by email or in person." },
        { q: "Can someone other than the parent pick the kid up?", a: "Yes — any adult named by the parent. Sign and email the \"Child pick-up consent\" form to kontakt@avetravel.pl." },
        { q: "What about two camps back-to-back?", a: "Either pick up the kid after the first camp and drop off again at 3:00 PM, or sign the solo-stay consent so they remain on-site (~4h) between camps without our supervision." }
      ]
    },
    crosspromo: {
      kicker: "The Scootive world",
      title: "More than a camp",
      shop: { title: "Scootive Shop", body: "Pro scooters, parts, accessories. Online + flagship in Warsaw.", cta: "Visit shop" },
      park: { title: "AvePark", body: "Poland's largest indoor skatepark. Open all year round.", cta: "Book a session" }
    },
    newsletter: {
      kicker: "Stay in the loop",
      title: "Get notified.",
      subtitle: "New dates, promos, special drops. No spam.",
      placeholder: "Your email",
      placeholder_name: "Your first name",
      cta: "Subscribe",
      success: "Thanks! You're on the list.",
      error: "Something went wrong. Try again."
    },
    contact: {
      kicker: "Contact", title: "Reach out.",
      address: "AvePark · Krakowiaków 80/98, 02-255 Warsaw"
    },
    footer: {
      tagline: "Poland's leading scooter camp.",
      rights: "All rights reserved.",
      brand: "Scootive Camp",
      camp_col: "Camp",
      camp_summer: "Summer",
      camp_winter: "Winter",
      camp_info: "Important info",
      shop_label: "Scootive Shop",
      privacy_link: "Privacy policy",
      cookie_settings: "Cookie settings",
      other: "Other",
      social_label: "Follow us",
      organizer: "Organiser",
      tax_id: "Tax ID",
      regon: "Statistical ID",
      krs: "Company reg. no.",
      registry_link: "Tour Operators Registry entry (PDF)",
      address_label: "Address",
      contact_label: "Contact",
      office_label: "AveTravel office"
    }
  }
};

export function I18nProvider({ children }) {
  const [lang, setLang] = useState(() => {
    if (typeof window === "undefined") return "pl";
    // URL query param takes precedence (great for shareable links).
    try {
      const q = new URLSearchParams(window.location.search).get("lang");
      if (q === "en" || q === "pl" || q === "uk") return q;
    } catch (e) { /* ignore */ }
    const stored = localStorage.getItem("scootive_lang");
    if (stored === "en" || stored === "pl" || stored === "uk") return stored;
    return "pl";
  });

  useEffect(() => {
    if (typeof window !== "undefined") {
      localStorage.setItem("scootive_lang", lang);
      document.documentElement.lang = lang;
    }
  }, [lang]);

  const t = { ...dict[lang], lang };
  return (
    <I18nContext.Provider value={{ lang, setLang, t }}>
      {children}
    </I18nContext.Provider>
  );
}

export function useI18n() {
  const ctx = useContext(I18nContext);
  if (!ctx) throw new Error("useI18n must be used within I18nProvider");
  return ctx;
}
